<template>
    <router-view/>
</template>
<script>
export default {
    name:'operation-layout'
}
</script>